import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Plus, Folder, MoreVertical, LogOut, Trash2, Copy } from 'lucide-react';
import { apiGet, apiPost } from './api';

export default function Dashboard() {
    const [formularios, setFormularios] = useState([]);
    const [pastas, setPastas] = useState([]);
    const [pastaAtiva, setPastaAtiva] = useState(null);
    const [carregando, setCarregando] = useState(true);
    const [menuAbertoId, setMenuAbertoId] = useState(null); // Controla qual menu dos 3 pontinhos está aberto
    const navigate = useNavigate();

    useEffect(() => {
        carregarFormularios();
    }, []);

    const carregarFormularios = async () => {
        try {
            const dados = await apiGet('/listar_formularios.php');
            if (dados.sucesso) {
                setFormularios(dados.formularios);
                setPastas(dados.pastas || []);
            }
        } catch (erro) {
            console.error("Erro ao carregar:", erro);
        } finally {
            setCarregando(false);
        }
    };

    const criarNovaPasta = async () => {
        const nomePasta = window.prompt("Digite o nome da nova pasta:");
        if (!nomePasta || nomePasta.trim() === '') return;
        try {
            await apiPost('/criar_pasta.php', { nome: nomePasta });
            carregarFormularios();
        } catch (e) { alert("Erro ao criar pasta."); }
    };

    const excluirPasta = async (pastaId, nomePasta) => {
        if (!window.confirm(`Tem certeza que deseja excluir a pasta "${nomePasta}"?\n\n(Os formulários dentro dela NÃO serão apagados, apenas voltarão para "Sem pasta").`)) return;
        try {
            await apiPost('/excluir_pasta.php', { pasta_id: pastaId });
            if (pastaAtiva === pastaId) setPastaAtiva(null);
            carregarFormularios();
        } catch (e) { alert("Erro ao excluir pasta."); }
    };

    const duplicarFormulario = async (formId) => {
        setMenuAbertoId(null);
        try {
            await apiPost('/duplicar_formulario.php', { form_id: formId });
            carregarFormularios();
        } catch (e) { alert("Erro ao duplicar formulário."); }
    };

    const excluirFormulario = async (formId, tituloForm) => {
        if (!window.confirm(`ATENÇÃO! Tem certeza que deseja excluir DEFINITIVAMENTE o formulário "${tituloForm}" e TODOS os seus leads?`)) return;
        try {
            await apiPost('/excluir_formulario.php', { form_id: formId });
            setMenuAbertoId(null);
            carregarFormularios();
        } catch (e) { alert("Erro ao excluir formulário."); }
    };

    const moverFormulario = async (formId, pastaId) => {
        try {
            await apiPost('/mover_formulario.php', { form_id: formId, pasta_id: pastaId });
            setMenuAbertoId(null);
            carregarFormularios();
        } catch (e) { alert("Erro ao mover formulário."); }
    };

    const sair = () => {
        localStorage.removeItem('unity_token');
        navigate('/');
    };

    const formulariosFiltrados = formularios.filter(f => {
        if (pastaAtiva === null) return true;
        if (pastaAtiva === 'sem_pasta') return !f.pasta_id;
        return f.pasta_id === pastaAtiva;
    });

    return (
        <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f9fafb', fontFamily: 'sans-serif' }} onClick={() => setMenuAbertoId(null)}>

            {/* BARRA LATERAL ESQUERDA */}
            <div style={{ width: '250px', backgroundColor: '#fff', borderRight: '1px solid #e5e7eb', padding: '20px' }}>

                <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    Unity Makers
                    <LogOut size={18} style={{ cursor: 'pointer', color: '#ef4444' }} onClick={sair} title="Sair" />
                </h2>

                <div style={{ marginBottom: '20px' }}>
                    <p style={{ fontSize: '12px', color: '#6b7280', fontWeight: 'bold', marginBottom: '10px' }}>PASTAS</p>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        <li
                            onClick={() => setPastaAtiva(null)}
                            style={{ padding: '8px 12px', backgroundColor: pastaAtiva === null ? '#f3f4f6' : 'transparent', borderRadius: '6px', fontWeight: pastaAtiva === null ? 'bold' : 'normal', marginBottom: '5px', cursor: 'pointer', fontSize: '14px', color: '#111827' }}
                        >
                            Todos os formulários
                        </li>

                        {pastas.map(pasta => (
                            <li
                                key={pasta.id}
                                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', backgroundColor: pastaAtiva === pasta.id ? '#f3f4f6' : 'transparent', borderRadius: '6px', fontWeight: pastaAtiva === pasta.id ? 'bold' : 'normal', marginBottom: '5px', cursor: 'pointer', fontSize: '14px', color: '#111827' }}
                            >
                                <span onClick={() => setPastaAtiva(pasta.id)} style={{ flex: 1 }}>{pasta.nome}</span>
                                <Trash2 size={14} color="#ef4444" onClick={() => excluirPasta(pasta.id, pasta.nome)} style={{ opacity: 0.6 }} />
                            </li>
                        ))}

                        <li
                            onClick={() => setPastaAtiva('sem_pasta')}
                            style={{ padding: '8px 12px', backgroundColor: pastaAtiva === 'sem_pasta' ? '#f3f4f6' : 'transparent', borderRadius: '6px', fontWeight: pastaAtiva === 'sem_pasta' ? 'bold' : 'normal', color: '#4b5563', cursor: 'pointer', fontSize: '14px' }}
                        >
                            Sem pasta
                        </li>
                    </ul>

                    <button onClick={criarNovaPasta} style={{ marginTop: '15px', display: 'flex', alignItems: 'center', gap: '8px', color: '#6b7280', border: '1px dashed #d1d5db', background: 'transparent', padding: '8px 12px', borderRadius: '6px', width: '100%', cursor: 'pointer', fontSize: '14px' }}>
                        <Plus size={16} /> Nova pasta
                    </button>
                </div>
            </div>

            {/* CONTEÚDO PRINCIPAL */}
            <div style={{ flex: 1, padding: '40px' }}>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '30px' }}>
                    <div style={{ position: 'relative', width: '350px' }}>
                        <Search size={18} style={{ position: 'absolute', top: '10px', left: '12px', color: '#9ca3af' }} />
                        <input type="text" placeholder="Pesquisar por nome ou ID..." style={{ width: '100%', padding: '10px 10px 10px 38px', borderRadius: '6px', border: '1px solid #d1d5db', outline: 'none', fontSize: '14px' }} />
                    </div>

                    <button onClick={() => navigate('/builder/novo')} style={{ display: 'flex', alignItems: 'center', gap: '8px', background: '#111827', color: 'white', padding: '10px 20px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: '500' }}>
                        <Plus size={18} /> Criar formulário
                    </button>
                </div>

                {/* Lista de Formulários */}
                <div style={{ background: 'white', borderRadius: '8px', border: '1px solid #e5e7eb', overflow: 'visible' }}>

                    {carregando ? (
                        <p style={{ padding: '20px', textAlign: 'center', color: '#6b7280' }}>Carregando...</p>
                    ) : formulariosFiltrados.length === 0 ? (
                        <p style={{ padding: '20px', textAlign: 'center', color: '#6b7280' }}>Nenhum formulário encontrado nesta pasta.</p>
                    ) : (
                        formulariosFiltrados.map((form, index) => (
                            <div key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid #e5e7eb', transition: 'background 0.2s' }} onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'} onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>

                                <div onClick={() => navigate('/builder/' + form.id)} style={{ display: 'flex', alignItems: 'center', gap: '15px', cursor: 'pointer', flex: 1 }}>
                                    <div style={{ width: '40px', height: '40px', background: '#f3f4f6', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Folder size={20} color="#4b5563" />
                                    </div>
                                    <div>
                                        <h3 style={{ margin: 0, fontSize: '15px', color: '#111827' }}>{form.titulo}</h3>
                                        <p style={{ margin: 0, fontSize: '11px', color: '#9ca3af' }}>{form.slug ? `/f/${form.slug}` : form.id}</p>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                    <span onClick={() => navigate('/crm/' + form.id)} style={{ fontSize: '14px', color: '#3b82f6', cursor: 'pointer', fontWeight: 'bold' }}>
                                        {form.respostas} respostas
                                    </span>
                                    <span style={{ fontSize: '11px', background: '#10b981', color: 'white', padding: '4px 8px', borderRadius: '4px', fontWeight: 'bold' }}>PUBLICADO</span>

                                    {/* OS 3 PONTINHOS E O MENU SUSPENSO */}
                                    <div style={{ position: 'relative' }}>
                                        <MoreVertical
                                            onClick={(e) => { e.stopPropagation(); setMenuAbertoId(menuAbertoId === form.id ? null : form.id); }}
                                            size={20} color="#9ca3af" style={{ cursor: 'pointer' }}
                                        />

                                        {menuAbertoId === form.id && (
                                            <div onClick={(e) => e.stopPropagation()} style={{ position: 'absolute', right: '0', top: '25px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)', padding: '10px', width: '200px', zIndex: 10 }}>
                                                <p style={{ fontSize: '10px', color: '#9ca3af', fontWeight: 'bold', margin: '0 0 8px 0', textTransform: 'uppercase' }}>Mover para pasta</p>

                                                {pastas.map(p => (
                                                    <div key={p.id} onClick={() => moverFormulario(form.id, p.id)} style={{ padding: '6px 8px', fontSize: '13px', cursor: 'pointer', borderRadius: '4px', color: '#4b5563' }} onMouseOver={(e) => e.target.style.background = '#f3f4f6'} onMouseOut={(e) => e.target.style.background = 'transparent'}>
                                                        📁 {p.nome}
                                                    </div>
                                                ))}
                                                <div onClick={() => moverFormulario(form.id, null)} style={{ padding: '6px 8px', fontSize: '13px', cursor: 'pointer', borderRadius: '4px', color: '#4b5563' }} onMouseOver={(e) => e.target.style.background = '#f3f4f6'} onMouseOut={(e) => e.target.style.background = 'transparent'}>
                                                    📁 Sem pasta
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        navigator.clipboard.writeText(`https://forms.unitymakers.com.br/f/${form.slug || form.id}`);
                                                        alert("Link do formulário copiado!");
                                                        setMenuAbertoId(null);
                                                    }}
                                                    style={{ padding: '6px 8px', fontSize: '13px', cursor: 'pointer', borderRadius: '4px', color: '#3b82f6', display: 'flex', alignItems: 'center', gap: '5px' }}
                                                    onMouseOver={(e) => e.target.style.background = '#eff6ff'}
                                                    onMouseOut={(e) => e.target.style.background = 'transparent'}
                                                >
                                                    🔗 Copiar link do formulário
                                                </div>

                                                <div
                                                    onClick={() => duplicarFormulario(form.id)}
                                                    style={{ padding: '6px 8px', fontSize: '13px', cursor: 'pointer', borderRadius: '4px', color: '#4b5563', display: 'flex', alignItems: 'center', gap: '5px' }}
                                                    onMouseOver={(e) => e.target.style.background = '#f3f4f6'}
                                                    onMouseOut={(e) => e.target.style.background = 'transparent'}
                                                >
                                                    <Copy size={14} /> Duplicar formulário
                                                </div>

                                                <hr style={{ margin: '8px 0', border: 'none', borderTop: '1px solid #e5e7eb' }} />

                                                <div onClick={() => excluirFormulario(form.id, form.titulo)} style={{ padding: '6px 8px', fontSize: '13px', color: '#ef4444', cursor: 'pointer', borderRadius: '4px', display: 'flex', alignItems: 'center', gap: '5px' }} onMouseOver={(e) => e.target.style.background = '#fee2e2'} onMouseOut={(e) => e.target.style.background = 'transparent'}>
                                                    <Trash2 size={14} /> Excluir formulário
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}